var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3289 22.0894C7.28889 22.0894 3.17889 17.9894 3.17889 12.9394V11.0594C3.17889 10.6694 3.49889 10.3594 3.87889 10.3594C4.25889 10.3594 4.57889 10.6794 4.57889 11.0594V12.9394C4.57889 17.2094 8.04889 20.6794 12.3189 20.6794C16.5889 20.6794 20.0589 17.2094 20.0589 12.9394V11.0594C20.0589 10.6694 20.3789 10.3594 20.7589 10.3594C21.1389 10.3594 21.4589 10.6794 21.4589 11.0594V12.9394C21.4789 17.9894 17.3689 22.0894 12.3289 22.0894Z",
    fill: "url(#paint0_linear_3780_18305)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3289 2.16016C8.96894 2.16016 6.22894 4.90016 6.22894 8.26016V12.9502C6.22894 16.3102 8.96894 19.0502 12.3289 19.0502C15.6889 19.0502 18.4289 16.3102 18.4289 12.9502V8.26016C18.4289 4.90016 15.6889 2.16016 12.3289 2.16016ZM14.5089 10.7502C14.4389 11.0202 14.1889 11.2002 13.9189 11.2002C13.8689 11.2002 13.8089 11.1902 13.7589 11.1802C12.7389 10.9002 11.6589 10.9002 10.6389 11.1802C10.3089 11.2702 9.97894 11.0802 9.88894 10.7502C9.79894 10.4302 9.98894 10.0902 10.3189 10.0002C11.5489 9.66016 12.8489 9.66016 14.0789 10.0002C14.4089 10.0902 14.5989 10.4202 14.5089 10.7502ZM15.3589 7.98016C15.2689 8.23016 15.0389 8.38016 14.7889 8.38016C14.7189 8.38016 14.6489 8.37016 14.5789 8.34016C13.0489 7.78016 11.3689 7.78016 9.83894 8.34016C9.51894 8.46016 9.16894 8.30016 9.04894 7.98016C8.93894 7.67016 9.09894 7.32016 9.41894 7.20016C11.2189 6.55016 13.1989 6.55016 14.9889 7.20016C15.3089 7.32016 15.4689 7.67016 15.3589 7.98016Z",
    fill: "url(#paint1_linear_3780_18305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_18305",
    x1: 12.3189,
    y1: 10.3594,
    x2: 12.3189,
    y2: 22.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3780_18305",
    x1: 12.3289,
    y1: 2.16016,
    x2: 12.3289,
    y2: 19.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicro);
export default __webpack_public_path__ + "static/media/micro.edd231206adf533f7de399ac15b4efa9.svg";
export { ForwardRef as ReactComponent };